import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router-dom";

export function initSentry(): void {
  if (!process.env.REACT_APP_SENTRY_DSN) return;

  Sentry.init({
    enabled: process.env.NODE_ENV === "production",
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    release: `${process.env.REACT_APP_NAME}@${process.env.REACT_APP_VERSION}`,
    debug: process.env.NODE_ENV === "development",
    normalizeDepth: 10,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    tracesSampler: () => {
      if (process.env.NODE_ENV === "development") return 1.0;
      return 0.2;
    },
    beforeSend(originalEvent) {
      const event = { ...originalEvent };

      if (event.request?.headers?.authorization) {
        event.request.headers = { ...event.request.headers };
        delete event.request.headers.authorization;
      }

      return event;
    },
  });

  // Sentry.setTag("branch", process.env.REACT_APP_BRANCH || "unknown");
  // Sentry.setTag("commit", process.env.REACT_APP_GIT_COMMIT || "unknown");
}
